import React, { useState, useRef } from "react";
import Header from "../../../component/Head";
import Footer from "../../../component/Footer";
import {
  Button,
  Col,
  Form,
  Input,
  Row,
  Radio,
  DatePicker,
  Cascader,
  message,
  Result,
  Modal,
  InputNumber,
} from "antd";
import {
  defaultGutter,
  editFormColSpan,
  formItemLayout,
} from "../../../static/formLayoutConfig";
import { address } from "../../../static/address";
import { bankSelect } from "../../../static/option";
import ImgUploader from "../../../component/ImgUploader";

import "./index.scss";
import formValid from "../../../func/formValid";
import ajax from "../../../func/ajax";
import moment from "moment";
import { useHistory } from "react-router-dom";

export default () => {
  const history = useHistory();
  const [otherBank, setOtherBank] = useState(null);
  const [liked, setLiked] = useState(true);
  const [count, setCount] = useState(60);
  const [showModal, setShowModal] = useState(false);
  const [form] = Form.useForm();
  const bank = useRef(""); //input事件保存输入的值
  //倒计时
  const sendCode = () => {
    let counts = count - 1;
    const timer = setInterval(() => {
      setCount(counts--);
      setLiked(false);
      if (counts <= -1) {
        clearInterval(timer);
        setLiked(true);
        setCount(60);
      }
    }, 1000);
  };

  //其他银行Input输入事件
  const handleInputBank = (e) => {
    console.log(e.target.value);
    // setOtherBank(e.target.value);
    bank.current = e.target.value;
    console.log(bank.current, "bank");
  };

  //ajax获取验证码
  const getCode = (phone) => {
    ajax({
      path: `/creditor/iphonesend/${phone}`,
      data: { phone },
      method: "get",
      isNeedToken: false,
    }).then((res) => {
      console.log(res);
      if (res.msg) {
        message.error(res.msg);
      }
    });
  };

  //验证码操作
  const verifiedSubmit = () => {
    let { phone } = form.getFieldsValue();
    console.log(phone, '1')
    const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
    if (phone && reg.test(phone)) {
      sendCode();
      getCode(phone);
    } else {
      message.error("请输入正确的手机号");
      return;
    }
  };
  const handleSubmit = () => {
    formValid(form).then(() => {
      let {
        name,
        phone,
        phone_code,
        id_card,
        intention_region,
        broker_code,
        broker_img,
        media_account,
        fans_num
      } = form.getFieldsValue();



      ajax({
        path: "/creditor/v1/broker",
        isNeedToken: false,
        data: {
          name,
          phone,
          phone_code,
          id_card,
          intention_region,
          broker_img: broker_img[0],
          media_account,
          fans_num,
          broker_code,
          m_type: 4,
        },
      }).then((res) => {
        console.log(res, 11)
        if (res.error_code === 0) {
          setShowModal(true);
        } else {
          message.error(res.message)
        }
      });
    });
  };

  return (
    <div className={"brokerApply-container"}>
      <Header currentIndex={5} />
      <div className={"brokerApply-content"}>
        <div className={"brokerApply-main"}>
          <div className={"brokerApply-header container-1200"}>申请入驻</div>
          <div className={"brokerApply-form container-1200"}>
            <Form
              form={form}
              {...formItemLayout}
              initialValues={{
                type: 3,
              }}
            >
              <div className={"brokerApply-form-item"}>
                <h3>填写入驻信息</h3>
                <Row gutter={defaultGutter}>
                  <Col {...editFormColSpan}>
                    <Form.Item
                      label={"姓名"}
                      name="name"
                      rules={[{ required: true, message: "该项为必填项" }]}
                    >
                      <Input placeholder={"请输入独立经纪人姓名"} allowClear />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={defaultGutter}>
                  <Col {...editFormColSpan}>
                    <Form.Item
                      label={"手机号"}
                      name="phone"
                      rules={[
                        {
                          required: true,
                          pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
                          message: "请输入手机号",
                        },
                      ]}
                    >
                      <Input placeholder={"请输入联系人手机号"} allowClear />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={defaultGutter}>
                  <Col {...editFormColSpan}>
                    <Form.Item
                      label={"手机验证码"}
                      name="phone_code"
                      rules={[{ required: true, message: "该项为必填项" }]}
                    >
                      <Input placeholder={"请输入手机验证码"} allowClear />
                    </Form.Item>
                  </Col>
                  <Col {...editFormColSpan}>
                    <Button
                      disabled={liked ? false : true}
                      onClick={verifiedSubmit}
                      className={liked ? "verificationCode" : ""}
                    >
                      {liked ? "获取验证码" : count + "秒后重发"}
                    </Button>
                  </Col>
                </Row>

                <Row gutter={defaultGutter}>
                  <Col {...editFormColSpan}>
                    <Form.Item
                      label={"身份证信息"}
                      name="id_card"
                      rules={[{ required: true, message: "该项为必填项" }]}
                    >
                      <Input placeholder={"请输入经纪人身份证号码"} allowClear />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={defaultGutter}>
                  <Col {...editFormColSpan}>
                    <Form.Item
                      label={"经纪人资格证编号"}
                      name="broker_code"
                      rules={[{ required: true, message: "该项为必填项" }]}
                    >
                      <Input placeholder={"请输入经纪人资格证编号"} allowClear />
                    </Form.Item>
                  </Col>
                </Row>


                <Row gutter={defaultGutter}>
                  <Col {...editFormColSpan}>
                    <Form.Item
                      label={"经纪人照片"}
                      name="broker_img"
                      rules={[{ required: true, message: "该项为必填项" }]}
                    >
                      <ImgUploader maxNumber={1} />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={defaultGutter}>
                  <Col {...editFormColSpan}>
                    <Form.Item
                      label={"自媒体账号"}
                      name="media_account"
                    >
                      <Input placeholder={"请输入自媒体账号"} allowClear />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={defaultGutter}>
                  <Col {...editFormColSpan}>
                    <Form.Item
                      label={"粉丝量"}
                      name="fans_num"
                    >
                      <InputNumber style={{ width: '100%' }} min={0} placeholder={"请输入粉丝数量"} allowClear />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={defaultGutter}>
                  <Col {...editFormColSpan}>
                    <Form.Item
                      label={"意向区域"}
                      name="intention_region"
                      rules={[{ required: false, message: "该项为必填项" }]}
                    >
                      <Cascader
                        fieldNames={{
                          label: "title",
                          value: "title",
                          children: "children",
                        }}
                        options={address}
                        placeholder="请选择"
                      />
                    </Form.Item>
                  </Col>
                </Row>

              </div>

            </Form>
          </div>
          <div className={"handle_submit"}>
            <Button onClick={handleSubmit} type={"primary"}>
              下一步
            </Button>
          </div>
          <Modal title="" closable={false} visible={showModal} footer={null}>
            <Result
              status="success"
              title="审核已提交"
              // subTitle="您的入驻信息已经提交申请，会在三个工作日内通过邮件答复"
              subTitle="您的入驻信息已经提交申请，客户经理会在三个工作日内联系您！"

              extra={[
                <Button
                  style={{ width: "120px", height: "40px" }}
                  type="primary"
                  key="console"
                  onClick={() => {
                    setShowModal(false);
                    history.push("/brokerIndex");
                  }}
                >
                  确定
                </Button>,
              ]}
            />
          </Modal>
        </div>
      </div>
      <Footer />
    </div>
  );
};
